
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1609846069977",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "2097",
    "data-darkreader-inline-fill": "",
    "width": "64",
    "height": "64"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M909.568 437.184a397.44 397.44 0 0 1-129.536 294.016v225.088a32 32 0 0 1-32 32 29.248 29.248 0 0 1-6.4-0.64l-224.896-44.16a30.912 30.912 0 0 0-6.4-0.576 31.488 31.488 0 0 0-5.888 0.576l-224.384 44.16a32.576 32.576 0 0 1-6.4 0.64 32 32 0 0 1-32-32v-225.088a398.528 398.528 0 1 1 667.904-294.016z m-280.704 279.104c3.84-1.6 7.744-3.328 11.456-5.12a302.464 302.464 0 0 0 84.864-59.776 309.056 309.056 0 0 0 30.144-35.008 303.104 303.104 0 1 0-488.576 0 309.056 309.056 0 0 0 30.144 35.008 302.464 302.464 0 0 0 84.8 59.776c3.776 1.792 7.616 3.52 11.456 5.12a303.808 303.808 0 0 0 235.712 0z m-291.2 80v82.56l148.352-29.12a125.824 125.824 0 0 1 24.576-2.432 130.24 130.24 0 0 1 24.512 2.368l149.312 29.248v-82.624a399.616 399.616 0 0 1-346.752 0z m264-406.912a47.872 47.872 0 0 1 0 95.68H420.352a47.872 47.872 0 0 1 0-95.68z",
        "p-id": "2098",
        "data-darkreader-inline-fill": "",
        "style": "--darkreader-inline-fill:#282b2b;"
      }
    }
  ]
})
    }
  